export const getSubscriptionTermDescriptions = (offer) => {
  // Used to express the length of a subscription recurrence
  // in different ways, since we phrase it differently in
  // different places...
  if (isYearSubscriptionOffer(offer)) return ['yearly', 'each year', 'year'];
  if (isThreeMonthSubscriptionOffer(offer))
    return ['trimonthly', 'every 3 months', '3 month period'];
  return ['periodically', `${offer.virtualQuantity} days`, `${offer.virtualQuantity}-day period`];
};

export const getFreeTrialTermDescriptions = (freeTrialNumDays) => {
  // Used to express the length of a subscription free trial period
  // in different ways, since we phrase it differently in
  // different places...
  if (!freeTrialNumDays) {
    return ['', ''];
  }

  if (freeTrialNumDays === 366) {
    // this is a special value, that we'll call "one year"
    return ['one year', 'that year'];
  }

  return [`${freeTrialNumDays}-day`, `those ${freeTrialNumDays} days`];
};

export const isSubscriptionOffer = (offer) => {
  if (!offer) return false;
  const subscriptionProductTypes = [
    'premium_pass_subscription',
    'premium_pass_subscription_restricted',
  ];
  return subscriptionProductTypes.includes(offer.productType);
};

export const isYearSubscriptionOffer = (offer) =>
  isSubscriptionOffer(offer) && offer.virtualQuantity === 366;

export const isThreeMonthSubscriptionOffer = (offer) =>
  isSubscriptionOffer(offer) && offer.virtualQuantity === 90;
